import { Button } from '@byecode/ui'
import React from 'react'

export const VariableTriggerWrapper = React.forwardRef<HTMLButtonElement, React.PropsWithChildren>(({ children, ...rest }, ref) => {
    return (
        <Button type="text" ref={ref} {...rest}>
            {children}
        </Button>
    )
})
